import isString from "./isString.util.js";
export const isEmptyStringUtil = (input, strict = false) => isString(input) && strict ? !input?.trim() : input === "";
export default isEmptyStringUtil;
